import { useSpringPageQuery } from '../../../shared/hooks/use-spring-page-query';
import { schoolsApi, type SchoolDataImportDto } from '../api/schools.api';

/**
 * Hook for fetching school import data (SIIIR catalog)
 *
 * Used by SchoolSelectionTable for searching official Romanian school catalog
 * during registration to autocomplete SIIIR codes.
 *
 * @param initialFilter - Optional initial filter values
 * @returns Query state with data, loading, pagination, and filter controls
 */
export function useSchoolImportData(initialFilter?: Partial<SchoolDataImportDto>) {
    return useSpringPageQuery({
        queryKey: ['schools', 'import-data'],
        fetchFn: schoolsApi.getImportData,
        initialFilter: initialFilter || {},
        initialPageable: {
            page: 0,
            size: 20,
            sort: ['numeInstitutieInvatamant,asc']
        }
    });
}
